import React, { useEffect, useState } from "react";
import { ArrowRight, Eye, MapPin } from "react-feather";
import Parser from "html-react-parser";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import NoDataFound from "../../Components/NoDataFound";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import Select from "react-select";
import CommonModal from "../../Components/CommonModal";
import moment from "moment";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import { toast } from "react-toastify";
import { PRIMARY_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import Notiflix from "notiflix";

const ManageApplication = () => {
  let columnDefs = [
    {
      field: "fld_code",
      header: "Job Id",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "fld_title",
      header: "Job Title",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_auditstatus",
      header: "Status",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
      body: (row) => (
        <span
          className={`${genareteColor(
            row.fld_auditstatus
          )} font-size-3 rounded-3 px-2`}
        >
          {row.fld_auditstatus}
        </span>
      ),
    },
    {
      field: "fld_city",
      header: "City",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "fld_state",
      header: "State",
      sortable: true,
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_type",
      header: "Job Type",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_remotework",
      header: "Remote",
      sortable: true,
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
    {
      field: "action",
      header: "Action",
      headerStyle: { width: "100px", minWidth: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
      body: (row) => (
        <div>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedAudit(row);
              setShowDetailModal(true);
              setAcceptApp({label:row.fld_auditorauditstatus, value:row.fld_auditorauditstatus});
            }}
          >
            <Eye size={15} /> View
          </span>
        </div>
      ),
    },
  ];

  const history = useHistory();
  const tempUser = useSelector((state) => state.login);
  const [appliedApplicant, setAppliedApplicant] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [jobStatus, setJobStatus] = useState({ value: "All", label: "All" });
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedAuditDetail, setSelectedAudit] = useState(null);
  const [acceptApp, setAcceptApp] = useState("");
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    (async () => {
      const res = await PostApiCall.postRequest(
        { id: tempUser?.fld_id, usertype: tempUser?.fld_usertype },
        "GetAppliedJobsUser"
      );
      const { data } = await res.json();
      setAppliedApplicant(data);
      setRefresh(false);
      setFilteredData(data);
    })();
  }, [refresh]);

  const handleSearch = (e) => {
    const keyword = e.target.value.toLowerCase();
    setSearchKeyword(keyword);
    filterData(keyword, jobStatus);
  };

  const handleJobStatusChange = (selectedOption) => {
    setJobStatus(selectedOption);
    filterData(searchKeyword, selectedOption);
  };

  const filterData = (search, filter) => {
    const filtered = appliedApplicant.filter((item) => {
      const searchMatches = Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      );
      const statusMatches =
        !filter ||
        filter.value === "All" ||
        item.fld_applicationstatus === filter.value;
      return searchMatches && statusMatches;
    });
    setFilteredData(filtered);
  };

  const AuditorSubmitHandler = async () => {
    try {
       Notiflix.Loading.standard();
      const res = await PostApiCall.postRequest(
        {
          userid: tempUser?.fld_id,
          auditstatus: selectedAuditDetail?.fld_auditstatus,
          recruiterremark: selectedAuditDetail?.fld_recruiterremark,
          auditid: selectedAuditDetail?.fld_auditid,
          auditorauditstatus: acceptApp?.value || "",
          currency: selectedAuditDetail.fld_currency,
          finalsalarytype: selectedAuditDetail.fld_finalsalarytype,
          finalprice: selectedAuditDetail.fld_finalprice,
        },
        "UpdateJobAuditApplicant"
      );
      const {data}=res.json()
      if (res.ok) {
        setRefresh(true);
        toast.success("Status updated successfully", {
          autoClose: delay,
        });
      }else{
        throw new Error(data.error)
      }
      Notiflix.Loading.remove();
    } catch (error) {
      toast.error(error.message || SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
      Notiflix.Loading.remove();
    }
    setShowDetailModal(false);
  };

  return (
    <div
      className=""
      // style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)", border: "none" }}
    >
      {/* {appliedApplicant.length > 0 ? ( */}
      <div
        className="p-2"
        // style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)", border: "none" }}
      >
        <Row className="filter-actions my-2 justify-content-between">
          <Col sx="12" md="3">
            <Input
              style={{
                border: "#cccccc solid 1px",
                height: "38px",
                borderRadius: "5px",
              }}
              className="mr-1 pt-0 shadow-sm"
              type="text"
              placeholder="search..."
              value={searchKeyword}
              onChange={handleSearch}
            />
          </Col>
          <Col sm="12" md="3">
            <div className="dropdown actions-dropdown" style={{ zIndex: 20 }}>
              <Select
                className="React"
                classNamePrefix="select "
                placeholder="Filter by"
                name="color"
                options={[
                  { value: "All", label: "All" },
                  { value: "Pending", label: "Pending" },
                  { value: "Review", label: "Review" },
                  { value: "Approved", label: "Approved" },
                  { value: "Rejected", label: "Rejected" },
                ]}
                value={jobStatus}
                onChange={handleJobStatusChange}
              />
            </div>
          </Col>
        </Row>

        <CustomDataTable
          data={filteredData}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
        {/* <DataTable
            highlightOnHover
            className="dataTable-custom mt-2"
            data={filteredData}
            columns={columnDefs}
            fixedHeader
            pagination
            paginationPerPage={10}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            onRowClicked={(row) => {
              setSelectedAudit(row);
              setShowDetailModal(true);
            }}
            customStyles={{
              table: {
                style: {
                  minHeight: "200px", // Set your desired minimum height
                },
              },
              head: {
                style: {
                  background: "transparent", // Remove the default background color
                },
              },
              headRow: {
                style: {
                  backgroundColor: "white",
                  color: "#ca8636",
                },
              },
              headCells: {
                style: {
                  fontSize: "14px",
                  textTransform: "capitalize",
                },
              },
            }}
          /> */}
      </div>
      {/* ) : (
        <div className="mx-3">
          <NoDataFound />
        </div>
      )} */}

      {showDetailModal && (
        <CommonModal
          isOpen={showDetailModal}
          toggle={() => setShowDetailModal(false)}
          heading={"Application Action"}
          contentBody={
            <div>
              <FormGroup>
                <Row>
                  {
                    selectedAuditDetail.fld_auditstatus !="Pending"  && (
                      <>
                      
                  <Col sm="3">
                    <Label htmlFor="">Currency</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={selectedAuditDetail.fld_currency || 'INR'}
                      disabled
                    />
                  </Col>
                  <Col sm="4">
                    <Label htmlFor="">Price</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={selectedAuditDetail.fld_finalprice}
                      disabled
                    />
                  </Col>
                  <Col sm="5">
                    <Label htmlFor="">Salary Type</Label>
                    <Input
                      type="text"
                      name="name"
                      id="nameVertical"
                      className="rounded-0"
                      value={selectedAuditDetail.fld_finalsalarytype}
                      disabled
                    />
                  </Col>
                      </>
                    )
                  }
                
                  {
                    selectedAuditDetail.fld_purposaldate !="" && 
                    <Col sm="12">
                      <Label htmlFor="">Proposed Date</Label>
                      <Input
                        type="text"
                        name="name"
                        id="nameVertical"
                        className="rounded-0"
                        value={moment(
                          selectedAuditDetail.fld_purposaldate
                        ).format("ll")}
                        disabled
                      />
                    </Col>
                  }
                </Row>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="exampleText">Auditor Remarks</Label>
                <Input
                  id="exampleText"
                  name="text"
                  type="textarea"
                  className="py-2"
                  disabled
                  value={selectedAuditDetail.fld_auditorremark}
                />
              </FormGroup>
              <FormGroup>
                <Label htmlFor="exampleText">Recruiter Remarks</Label>
                <Input
                  id="exampleText"
                  name="text"
                  type="textarea"
                  className="py-2"
                  disabled
                  value={selectedAuditDetail.fld_recruiterremark}
                />
              </FormGroup>
              {selectedAuditDetail?.fld_auditstatus == "Approved" && (
                <>
                  <Label for="nameVertical">
                    Audit Acceptance
                    <span className="mandatory">*</span>
                  </Label>
                  <Select
                    className=""
                    classNamePrefix="select"
                    placeholder="Select"
                    name="color"
                    options={[
                      { value: "Accepted", label: "Accepted" },
                      { value: "Rejected", label: "Rejected" },
                    ]}
                    onChange={(selectedOption) => {
                      setAcceptApp(selectedOption);
                    }}
                    value={acceptApp}
                  />
                </>
              )}
            </div>
          }
          confirmText={"Submit"}
          onConfirm={AuditorSubmitHandler}
          cancelText={"Cancel"}
          onCancel={() => setShowDetailModal(false)}
        />
      )}
    </div>
  );
};

export default ManageApplication;
